module.exports = __webpack_public_path__ + "img/bus.aca25dbb.jpg";